import { Result } from '@/classes'

export const metadataGetAPI = async (
  link: string
) => {
  try {
    if (!link) return null

    const response: Result<{ metadata: any }> = await fetchAPI('metadata', { link })

    if (!response.ok) return null

    return response.data.metadata
  } catch (e) {
    console.warn(e)
    return null
  }
}
